import Swiper, {
  Navigation,
  Autoplay,
  EffectCreative,
  EffectFade,
} from "swiper";
import "swiper/css";
import "swiper/css/autoplay";

function imagesSlider() {
  const isPresent = document.querySelector(".images-slider");
  if (!isPresent) {
    return;
  }

  const slider = new Swiper(".images-slider", {
    modules: [Navigation, Autoplay, EffectCreative, EffectFade],
    loop: true,
    autoplay: true,
    // slidesPerView: "auto",
    grabCursor: true,
    effect: "creative",
    creativeEffect: {
      prev: {
        shadow: true,
        translate: ["-120%", 0, -500],
      },
      next: {
        shadow: true,
        translate: ["120%", 0, -500],
      },
    },
    // effect: "fade",
    // fadeEffect: {
    //   crossFade: true,
    // },
    keyboard: {
      enabled: true,
    },
    speed: 800,
    autoHeight: true,
    // setWrapperSize: true,
    navigation: {
      nextEl: ".images-slider-next",
      prevEl: ".images-slider-prev",
    },
  });
}

export { imagesSlider };
